import streetTires from '../../../Assets/technical_info/street_tires.png'
import touringTires from '../../../Assets/technical_info/touring_tires.png'
import superSportTires from '../../../Assets/technical_info/super_sport_tires.png'
import enduroTires from '../../../Assets/technical_info/enduro_tires.png'
import trackTires from '../../../Assets/technical_info/track_tires.png'

const TechnicalLV3 = () => {
    return (
        <div>

            <p><span style={ { fontSize: "24px" } }><strong>Lai saprastu, kādas riepas būtu nepieciešamas dzelzs rumakam, ir jāsaprot, kāds ir tavs braukšanas stils.</strong></span></p>

            <p>&nbsp;</p>

            <p><img alt="" src={streetTires} style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto"} } /></p>
                        
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Sporta ielas riepas</strong> ir piemērotas agresīvākiem braucējiem, kuri lielāko daļu laika pavada, aktīvi braucot pa publiskajiem ceļiem. Pateicoties daudzkomponentu sastāvam, riepu sānu malas ir mīkstākas, kas uzlabo manevrēšanu, savukārt riepas centrs ir veidots no cietāka sastāva, lai tā kalpotu ilgāk. Ielu un sporta ielu riepām ir laba saķere arī aukstākā laikā, bet, kad tās ir pārāk uzsilušas, saķere var samazināties.</p>

			<p>&nbsp;</p>

            <p><img alt="" src={touringTires} style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto"} } /></p>
                        
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Sport Touring riepas</strong> parasti tiek izgatavotas no izturīgāka gumijas sastāva. Tām bieži ir ilgāks kalpošanas laiks, taču pie optimālas temperatūras tās parasti nodrošina mazāku saķeri nekā sporta riepas. Kompromiss ir tas, ka tūrisma riepas parasti piedāvā labāku saķeri zemākās temperatūrās, tāpēc tās ir piemērotākas braukšanai vēsākā laikā, kad sporta riepas ne vienmēr sasniedz optimālo darba temperatūru. Moto Touring riepas ir pieejamas plašā klāstā pie Tireshop.</p>

			<p>&nbsp;</p>

            <p><img alt="" src={superSportTires} style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto"} } /></p>
                        
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Super Sport riepas</strong> nodrošina izcilu saķeri, taču to kalpošanas resurss parasti ir īsāks (aptuveni 1600 km vai mazāk, atkarībā no braukšanas stila). Ir arī riepu tipi, kas izstrādāti īpaši sacensībām. Šīs riepas piedāvā ļoti augstu saķeri pagriezienos. Tā kā tās ir paredzētas darbam augstākā temperatūrā, ikdienas braukšanā pa ielu tās ne vienmēr sasniedz optimālo darba režīmu, un saķere var būt nepietiekama. Sacīkšu apstākļos riepas parasti tiek iepriekš uzsildītas ar riepu sildītājiem. Super Moto Sport riepas ir pieejamas plašā klāstā pie Tireshop.</p>

			<p>&nbsp;</p>

            <p><img alt="" src={enduroTires} style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto"} } /></p>
                        
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Off road / Enduro riepām</strong> ir izteikti, dziļi protektori maksimālai saķerei un netīrumu, dubļu, smilts vai grants izvadīšanai. Šādas riepas uz cieta ceļa seguma parasti ir mazāk stabilas.</p>

			<p>&nbsp;</p>

            <p><img alt="" src={trackTires} style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto"} } /></p>
                        
            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>Trases (slick) moto riepas ir paredzētas trasēm un sacīkstēm.</strong> Tām bieži ir izteiktāks trīsstūrveida profils, kas nodrošina lielāku saskares laukumu līkumā, kad motocikls ir noliecies. Ražotāji šīs riepas neiesaka izmantot uz ielām, un tās ir zināmas ar īsāku kalpošanas laiku, braucot pa publiskajiem ceļiem. Tā kā šīm riepām nav protektora, uz slapja ceļa saķere būtiski samazinās. Sacīkšu slick riepas parasti tiek ražotas no mīkstāka gumijas maisījuma un nesniedz pilnvērtīgu veiktspēju, kamēr nav uzsilušas līdz augstākai darba temperatūrai.</p>

			<p>&nbsp;</p>

        </div>
    );
};

export default TechnicalLV3;


